import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiEndpoints } from '../../http/api-endpoints';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Notification } from '../../models/notifications/notification.model';
import { Revision } from '../../models/notifications/revision.model';
import { PaginationCriteria, PaginationCriteriaSort, PaginatedResult } from 'jul-web-shared-lib';
import { JulContextLibService } from 'jul-web-shared-lib/src/lib/components/context';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {

  constructor(private http: HttpClient, private julContextService: JulContextLibService) { }

  getPaginated(criteria: PaginationCriteria<Notification>): Observable<PaginatedResult<Notification[]>> {
    this.julContextService.setContextNational();
    let paginatedResult: PaginatedResult<Notification[]> = new PaginatedResult<Notification[]>();

    return this.http.post(ApiEndpoints.core.notification.search(), criteria, {observe: 'response'}).pipe(
      map((response: any)  => {
        paginatedResult = response.body.data;
        return paginatedResult;
      }
    ));
  }

  getUnreads(idUser: string): Observable<any> {
    this.julContextService.setContextNational();
    const filter = {
      'filters': {
        'read': false,
        'idUser': idUser
      }
    };
    return this.count(filter);
  }

  getCount(): Observable<any> {
    this.julContextService.setContextNational();
    return this.http.post<Notification>(ApiEndpoints.core.notification.count(), {"filters": {"archived": false, "read": false }}).pipe(
      map((response: any)  => <Notification>response.data)
    );
  }

  read(id:string){
    this.julContextService.setContextNational();
    return this.http.put(ApiEndpoints.core.notification.read(id), null);
  }

  unread(id: string) {
    this.julContextService.setContextNational();
    const notification = {id: id} as Notification;
    return this.http.post(ApiEndpoints.core.notification.unread(), notification);
  }

  archive(id:string){
    this.julContextService.setContextNational();
    let archive = {
      "bulkOperation": "ARCHIVE",
      "justification": null,
      "ids": [
        id
      ]
    };
    return this.http.put(ApiEndpoints.core.notification.archive(), archive);
  }

  multipleArchive(idArrays: any){
    this.julContextService.setContextNational();
    let archive = {
      "bulkOperation": "ARCHIVE",
      "justification": null,
      "ids": idArrays
    };
    return this.http.put(ApiEndpoints.core.notification.archive(), archive);
  }

  restore(id: string) {
    this.julContextService.setContextNational();
    const notification = {id: id} as Notification;
    return this.http.post(ApiEndpoints.core.notification.restore(), notification);
  }

  getAll(): Observable<Notification[]> {
    this.julContextService.setContextNational();
    return this.http.get<Notification[]>(ApiEndpoints.core.notification.getAll()).pipe(
      map((response: any)  => <Notification[]>response.data)
    );
  }

  get(id: string): Observable<Notification> {
    this.julContextService.setContextNational();
    return this.http.get<Notification>(ApiEndpoints.core.notification.get(id)).pipe(
      map((response: any)  => <Notification>response.data)
    );
  }

  getRevisions(criteria: PaginationCriteria<Revision>): Observable<PaginatedResult<Revision[]>> {
    this.julContextService.setContextNational();
    let paginatedResult: PaginatedResult<Revision[]> = new PaginatedResult<Revision[]>();

    return this.http.post(ApiEndpoints.core.notification.revisions(), criteria, {observe: 'response'}).pipe(
      map((response: any)  => {
        paginatedResult = response.body.data;
        return paginatedResult;
      }
    ));
  }

  count(filter: any): Observable<any> {
    this.julContextService.setContextNational();
    return this.http.post(ApiEndpoints.core.notification.count(), filter).pipe(
      map((response: any)  => {
        return response.data;
      })
    );
  }

  create(notification: Notification) {
    this.julContextService.setContextNational();
    return this.http.post(ApiEndpoints.core.notification.post(), notification);
  }

  update(notification: Notification) {
    this.julContextService.setContextNational();
    return this.http.put(ApiEndpoints.core.notification.put(), notification);
  }


  delete(id: string, versionNumber: string) {
    this.julContextService.setContextNational();
    return this.http.delete(ApiEndpoints.core.notification.delete(id, versionNumber));
  }
}
